<div class="center">
    <ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="selectedFiles($event)" #fileSelector>
        <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
            {{ options.explanation }}
            <button mat-raised-button class="btn" color="primary" (click)="openFileSelector()">Seç</button>
        </ng-template>
    </ngx-file-drop>

    <div *ngIf="files?.length" class="upload-table">
        <table class="table">
            <thead>
                <tr>
                    <th>Seçilen Dosyalar</th>
                    <th>İşlem</th>
                </tr>
            </thead>
            <tbody class="upload-name-style">
                <tr *ngFor="let item of files; let i=index">
                    <td><strong>{{ item.relativePath }}</strong></td>
                    <td>
                        <button type="button" class="btn btn-icon btn-flat-success" rippleEffect
                            (click)="removeFile(i)">
                            <span [data-feather]="'trash'"></span></button>
                    </td>
                </tr>
            </tbody>
        </table>
        <button type="button" class="btn btn-relief-success" (click)="confirmUpload()">Onayla</button>
    </div>
</div>